<emr-modal
  [bsModalRef]="bsShowDistanceModalRef"
  customHeaderClass="user-message-header"
  (onCloseClick)="onPopupCancel()"
>
  <div modal-body class="col-md-12 user-message">
    <div class="row pt-3 pl-3 pr-3 pb-3">
      <div class="col-md-4">
        <img src="assets/copeland_blue_transparent.png" class="mt-n3 w-100" />
      </div>
    </div>
    <div class="pl-3 pr-3 scrollable-user-messsage-modal">
      <!-- <p class=" ">Dear Valued Customer,</p> -->
      <p><b> Scheduled Maintenance Notice </b></p>
      <p class="text-justify">
        Please be advised that Oversight will undergo routine maintenance on Saturday, January 10, starting at 10:00 PM EST.
         During this time, users may experience brief downtime or intermittent access issues.
      </p>
      <p>We expect the maintenance to be completed within one hour and appreciate your patience.</p>
      <p>Thank you,<br>
        The Oversight Team
      </p>
      <!-- <ul>
        <li>
          Oversight for trackers web access (portal availability), and
        </li>
        <li>
          Tracker IoT data transmission (device updates).
        </li>
      </ul>
      <p>
        <b>
        All other regions will remain operational.</b>
      </p> -->
      <p>
        If you have any questions, please contact 24/7 Technical Support:
        1-877-998-7299 or
        <a href="mailto:ColdChain.TechnicalServices@copeland.com"
          >ColdChain.TechnicalServices@copeland.com</a
        >
      </p>
    </div>
    <div class="modal-footer p-0">
      <div class="pb-3">
        <emr-button
          identifier="closeMessage"
          buttonType="reset"
          buttonText="Close"
          i18n-buttonText="@@close"
          cssClass="btn-outline-default reset-btn"
          (onClick)="onPopupCancel()"
        >
        </emr-button>
      </div>
    </div>
  </div>
</emr-modal>
